import { useState, useEffect } from "react";
import { t } from '../locales/translate.js';

function Element({ apiCall }) {

  const [text, setText] = useState("");
  const [title, setTitle] = useState('...');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch reports data when the component mounts
    apiCall("GET", "terms")
      .then(({ response, error }) => {

        if (error) {
          console.error("Error fetching terms:", error);
        } else {
          setText(response?.content || t('loading_terms_and_conditions'));
          setTitle(response?.title || '...');
        }
        setLoading(false);
      });
  }, [apiCall]);

  if (loading) {
    return <div>{t('loading')}</div>;
  }

    return (
        <div className="col-sm-12">
            <div className="card">
                <div className="card-header">
                    <h5>
                      <div dangerouslySetInnerHTML={{ __html: title }} />
                    </h5>
                </div>
                <div className="card-body">
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                </div>

            </div>
        </div>
    );
}

export default Element;
